module.exports = __webpack_public_path__ + "img/arrow-right.c3da6450.png";